export type ColorSlot = { fg: string; bg: string }

export const PALETTE: ColorSlot[] = [
  { fg: '#7a4fb5', bg: '#f2ecfa' },
  { fg: '#2c5db0', bg: '#e4ecf8' },
  { fg: '#0f7a4a', bg: '#e6f4ec' },
  { fg: '#a46a00', bg: '#fbf1da' },
  { fg: '#b3261e', bg: '#fbe9e8' },
  { fg: '#0d7c8a', bg: '#e1f3f5' },
  { fg: '#9c2780', bg: '#f7e6f1' },
]

export const CATEGORY_COLORS: Record<string, ColorSlot> = {
  client: PALETTE[1],
  campaign: PALETTE[0],
  tag: PALETTE[2],
  authentication: PALETTE[3],
  seat: PALETTE[5],
}

export const ACCENT_50 = '#f2ecfa'
export const ACCENT_100 = '#e6dbf4'
export const DIVIDER_BG = '#f7f8fa'
export const BORDER = '#e2e4eb'
export const MUTED_TEXT = '#6b6f7c'
export const MUTED_TEXT_SOFT = '#9096a3'
export const HAIRLINE = '#f0f0f0'

export const AVATAR_HUES = ['#ff8266', '#7a4fb5', '#4a9dc9', '#55b67a', '#b57a4f', '#778090']

export const RAW_PAYLOAD = {
  bg: '#0f1117',
  fg: '#d8dce6',
  key: '#c29bff',
  string: '#9edb9e',
  number: '#ffb366',
  bool: '#7eb3ff',
}
